/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon_shoujihao': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M753.152 1024H270.706A128.313 128.313 0 0 1 142.08 896V128A128.313 128.313 0 0 1 270.706 0H753.01a128.313 128.313 0 0 1 128.625 128v768a128.313 128.313 0 0 1-128.625 128zm64.313-896a64.17 64.17 0 0 0-64.313-64H270.706a64.17 64.17 0 0 0-64.313 64v32.086h610.93V128zm0 96h-610.93v511.004h610.93zm0 575.004h-610.93V896a64.17 64.17 0 0 0 64.313 64h482.304a64.142 64.142 0 0 0 64.313-64v-96.996zM512 928.085a48.014 48.014 0 1 1 48.213-48.014A48.1 48.1 0 0 1 512 928.085zm0 0z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/icon_shoujihao.js